"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/FirstTimeInteractables/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _notification = require('web/services/notification');
var _wizard = require('web/services/wizard');
var _FirstTimeModal = require('web/components/Welcome/FirstTimeModal'); var _FirstTimeModal2 = _interopRequireDefault(_FirstTimeModal);
var _EnableQuickLoginPopup = require('./EnableQuickLoginPopup'); var _EnableQuickLoginPopup2 = _interopRequireDefault(_EnableQuickLoginPopup);
var _DirectoryCreateNewModal = require('web/screens/Directory/DirectoryCreateNewModal'); var _DirectoryCreateNewModal2 = _interopRequireDefault(_DirectoryCreateNewModal);
var _types = require('web/screens/Directory/types');
var _Snackbar = require('web/components/Snackbar'); var _Snackbar2 = _interopRequireDefault(_Snackbar);
var _Idle = require('web/components/Idle'); var _Idle2 = _interopRequireDefault(_Idle);
var _user = require('shared/selectors/user');
var _downloadModalFlag = require('web/screens/onboardingShared/downloadModalFlag');


var _hooks = require('web/services/hooks');
var _firstTimeTutorial = require('web/reducers/firstTimeTutorial');

// The legacy first-login popup is redundant for sessions that came through
// the self-serve onboarding continuation (they just saw the real offer, and
// the landing shows exactly one dialog — the download prompt). The queue is
// built at login bootstrap, before onboarding sets its breadcrumb, so the
// suppression has to happen here at display time.
const LEGACY_FIRST_LOGIN_POPUPS = ['FIRST_TIME_POPUP']

// All optional: stands in for the class's `defaultProps = { interactable: {} }`.













// Stands in for the class's `defaultProps = { interactable: {} }`.
const NO_INTERACTABLE = {}

const isSuppressedLegacyPopup = (id) =>
  !!id && LEGACY_FIRST_LOGIN_POPUPS.includes(id) && _downloadModalFlag.arrivedFromOnboarding.call(void 0, )

const makeSnackbars = (userKey) => ({
  ENABLE_NOTIFICATIONS_SUGGESTION: {
    iconSrc: '/assets/icons/snackbars/bell.svg',
    text: 'Get alerts for new messages.',
    linkText: 'Enable notifications',
    onLinkClick: _notification.askForPermissionFunction,
  },
  ENABLE_QUICK_LOGIN_SUGGESTION: {
    iconSrc: '/assets/icons/snackbars/lock.svg',
    text: 'Quickly log in to BloomText using a 4-digit PIN code.',
    linkText: 'Enable Quick Login',
    onLinkClick: () => _actions2.default.pushInteractablesQueue({ type: 'POPUP', id: 'ENABLE_QUICK_LOGIN_POPUP' }),
    onAnyAction: () => _wizard.addUserToAwareOfQuickLoginList.call(void 0, userKey),
  },
}) 

const addCoworkers = () =>
  _actions2.default.pushInteractablesQueue({ type: 'POPUP', id: 'ADD_PEOPLE_POPUP' })

const selectUserKey = (state) => _user.selectCurrentUser.call(void 0, state).UserKey
const selectDisplayUserName = (state) => {
  const me = _user.selectCurrentUser.call(void 0, state)
  return me.FirstName || me.Name
}

// Memoized, as connect() was.
const FirstTimeInteractablesScreen = _react.memo.call(void 0, function FirstTimeInteractablesScreen () {
  const interactable = _nullishCoalesce(_hooks.useAppSelector.call(void 0, _firstTimeTutorial.selectActiveInteractable), () => ( NO_INTERACTABLE))
  const userKey = _hooks.useAppSelector.call(void 0, selectUserKey)
  const displayUserName = _hooks.useAppSelector.call(void 0, selectDisplayUserName)

  // Built once with the first user key, like the class constructor.
  const [allSnackbars] = _react.useState(() => makeSnackbars(userKey))

  // The handlers are stable and read the current id when they run, as the
  // class methods did. Idle subscribes its callbacks only on mount, so a new
  // handler per id would leave it calling a stale one.
  const interactableId = _react.useRef.call(void 0, interactable.id)
  _react.useLayoutEffect.call(void 0, () => {
    interactableId.current = interactable.id
  })

  const dismissInteractable = _react.useCallback.call(void 0, () => {
    // SAFETY: this runs only from an interactable on screen, so the id is set.
    _actions2.default.dismissInteractableById(interactableId.current )
  }, [])

  const permitCurrentInteractable = _react.useCallback.call(void 0, () => {
    // SAFETY: only a shown tooltip's Idle calls this, so the id is set.
    _actions2.default.permitInteractable(interactableId.current )
  }, [])

  // componentDidMount + componentDidUpdate on an id change.
  _react.useEffect.call(void 0, () => {
    if (isSuppressedLegacyPopup(interactable.id)) dismissInteractable()
  }, [interactable.id, dismissInteractable])

  const activeSnackbar = interactable.type === 'SNACKBAR' && interactable.id !== undefined &&
    allSnackbars[interactable.id]

  const isTooltip = interactable.type === 'TOOLTIP'

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  activeSnackbar &&
        _react2.default.createElement(_Snackbar2.default, {
          key: interactable.id,
          iconSrc: activeSnackbar.iconSrc,
          text: activeSnackbar.text,
          linkText: activeSnackbar.linkText,
          onClose: dismissInteractable,
          onLinkClick: activeSnackbar.onLinkClick,
          onAnyAction: activeSnackbar.onAnyAction, __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}
        )
      
      , _react2.default.createElement(_FirstTimeModal2.default, {
        isOpen: interactable.id === 'FIRST_TIME_POPUP' && !isSuppressedLegacyPopup(interactable.id),
        onAddPeople: addCoworkers,
        onClose: dismissInteractable,
        displayUserName: displayUserName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}
      )
      , _react2.default.createElement(_EnableQuickLoginPopup2.default, {
        isOpen: interactable.id === 'ENABLE_QUICK_LOGIN_POPUP',
        onClose: dismissInteractable, __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}
      )
      ,  interactable.id === 'ADD_PEOPLE_POPUP' &&
        _react2.default.createElement(_DirectoryCreateNewModal2.default, {
          isOpen: true,
          onClose: dismissInteractable,
          directoryTypeHint: _types.DirectoryTab.COWORKERS,
          // The class passed `orgHint`, which the modal never read, so it
          // always fell back to the selected org. null keeps that.
          orgKeyContext: null, __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}
        )
      ,  isTooltip && !interactable.isPermitted &&
        _react2.default.createElement(_Idle2.default, {
          timeout: 2000,
          onIdle: permitCurrentInteractable, __self: this, __source: {fileName: _jsxFileName, lineNumber: 140}}
        )
      
      ,  isTooltip && interactable.isPermitted &&
        _react2.default.createElement(_Idle2.default, {
          timeout: 8000,
          onIdle: dismissInteractable, __self: this, __source: {fileName: _jsxFileName, lineNumber: 146}}
        )
      
    )
  )
})

exports. default = FirstTimeInteractablesScreen
